/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.leads.rpc.LeadsSettingsRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const getWorkflowSettingsRpc = {
  serviceName: 'com.hubspot.leads.rpc.LeadsSettingsRpc',
  rpcName: 'getWorkflowSettings',
  auth: 'app',
  fingerprint: 'YZI049LDRd3IyyjDTy0VVVj_laZ-DZoZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const saveWorkflowSettingsRpc = {
  serviceName: 'com.hubspot.leads.rpc.LeadsSettingsRpc',
  rpcName: 'saveWorkflowSettings',
  auth: 'app',
  fingerprint: 'MiwfvTW95xKOUe2e_r4XmVj_laZ-DZoZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const saveLifecycleStageAutomationRpc = {
  serviceName: 'com.hubspot.leads.rpc.LeadsSettingsRpc',
  rpcName: 'saveLifecycleStageAutomation',
  auth: 'app',
  fingerprint: 'KT36LFFpNzaOUe2e_r4XmVj_laZ-DZoZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getLifecycleStageAutomationRpc = {
  serviceName: 'com.hubspot.leads.rpc.LeadsSettingsRpc',
  rpcName: 'getLifecycleStageAutomation',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAY17sQEzod2lj_laZ-DZoZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getLeadSettingsRpc = {
  serviceName: 'com.hubspot.leads.rpc.LeadsSettingsRpc',
  rpcName: 'getLeadSettings',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAC069U4MCNxpFj_laZ-DZoZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const saveLeadSettingsRpc = {
  serviceName: 'com.hubspot.leads.rpc.LeadsSettingsRpc',
  rpcName: 'saveLeadSettings',
  auth: 'app',
  fingerprint: 'yrRn9Z0KsI-OUe2e_r4XmVj_laZ-DZoZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPipelineSettingsRpc = {
  serviceName: 'com.hubspot.leads.rpc.LeadsSettingsRpc',
  rpcName: 'getPipelineSettings',
  auth: 'app',
  fingerprint: 'NRX4i6SmG9ewAkaciWzug1j_laZ-DZoZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const savePipelineSettingsRpc = {
  serviceName: 'com.hubspot.leads.rpc.LeadsSettingsRpc',
  rpcName: 'savePipelineSettings',
  auth: 'app',
  fingerprint: 'DjhHrJ8YzLmOUe2e_r4XmVj_laZ-DZoZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllPipelineSettingsRpc = {
  serviceName: 'com.hubspot.leads.rpc.LeadsSettingsRpc',
  rpcName: 'getAllPipelineSettings',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACdug5KQQ9R2Vj_laZ-DZoZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deletePipelineSettingsRpc = {
  serviceName: 'com.hubspot.leads.rpc.LeadsSettingsRpc',
  rpcName: 'deletePipelineSettings',
  auth: 'app',
  fingerprint: 'NRX4i6SmG9eOUe2e_r4XmVj_laZ-DZoZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};